<mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">

    <mat-card-content class="card-content">

        <!--   <div *ngIf="current_lang=='ar'" [innerHtml]="item.cont2"></div>
          <div *ngIf="current_lang=='fr'" [innerHTML]="item.cont1"></div>
          <div *ngIf="current_lang=='en'" [innerHtml]="item.contEn"></div>
<div *ngIf="id==4" style='text-align: center;'>
 <p><iframe src="https://www.google.com/maps/d/u/0/embed?mid=1XcGlGqj1YT90jMRPXRi5-eb-qVA" width="640" height="480"></iframe></p></div>  -->


        <div #frContainer></div>


    </mat-card-content>
</mat-card>
<app-spinner-container [isLoading]="!item"></app-spinner-container>





